// export const formatDate = (dateString) => {
//     if (!dateString) return '';

//     const date = new Date(dateString);

//     // Check if date is valid
//     if (isNaN(date.getTime())) return '';

//     return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//     });
// };

//added a time flag option
export const formatDate = (dateString, withTime = false) => {
    if (!dateString) return '';

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const year = String(date.getFullYear()); // last two digits

    let formattedDate = `${month}/${day}/${year}`;

    if (withTime) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        formattedDate += ` ${hours}:${minutes}`;
    }

    return formattedDate;
};

